import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例
import { param } from 'jquery';
const social = {
  FindGroupByUsersId(params) {
    return axios.post(
      `${base.dev}/services/app/Group/FindGroupByUsersId`,
      params
    );
  },
  MessageUpdate(params) {
    return axios.post(`${base.dev}/services/app/Message/Update`, params);
  },
  AddMessageLike(params) {
    return axios.get(`${base.dev}/services/app/Group/AddMessageLike`, {
      params
    });
  },
  AdminGroupGetAllList(params) {
    return axios.get(`${base.dev}/services/app/AdminGroup/GetAllList`, {
      params
    });
  },
  AdminGroupUpdateStatus(params) {
    return axios.get(`${base.dev}/services/app/AdminGroup/UpdateStatus`, {
      params
    });
  },
  UpdateMoiveCommunity(params) {
    return axios.post(
      `${base.dev}/services/app/Group/UpdateMoiveCommunity`,
      params
    );
  },
  GetMoiveCommunityByGroupId(params) {
    return axios.get(
      `${base.dev}/services/app/Group/GetMoiveCommunityByGroupId`,
      { params }
    );
  },
  UploadTempPhotoSharDel(params) {
    const url = `?temp=${params.temp}&fileName=${params.fileName}`;
    return axios.post(
      `${base.dev}/TokenAuth/UploadTempPhotoSharDel` + url,
      null
    );
  },
  PushGroupCommunity(params) {
    return axios.post(
      `${base.dev}/services/app/MoiveCommunity/PushGroupCommunity`,
      params
    );
  },
  UpdateMoive(params) {
    return axios.put(
      `${base.dev}/services/app/MoiveCommunity/UpdateMoive`,
      params
    );
  },
  MutualFriends(params) {
    return axios.post(`${base.dev}/services/app/Group/MutualFriends`, params);
  },
  FindMoiveCommunityByGroupId(params) {
    return axios.post(
      `${base.dev}/services/app/Group/FindMoiveCommunityByGroupId`,
      params
    );
  },
  UpdateGroupMsgVideo(params) {
    return axios.post(
      `${base.dev}/services/app/Group/UpdateGroupMsgVideo`,
      params
    );
  },
  ExitGroup(params) {
    return axios.post(`${base.dev}/services/app/Group/ExitGroup`, params);
  },
  GetMyGroupList(params) {
    return axios.get(`${base.dev}/services/app/Group/GetMyGroupList`, {
      params
    });
  },
  GroupDelete(params) {
    return axios.post(`${base.dev}/services/app/Group/Delete`, params);
  },
  GroupUpdate(params) {
    return axios.post(`${base.dev}/services/app/Group/Update`, params);
  },
  GroupCreate(params) {
    return axios.post(`${base.dev}/services/app/Group/Create`, params);
  },
  GroupGetAll(params) {
    return axios.get(`${base.dev}/services/app/Group/GetAll`, { params });
  },
  GroupGet(params) {
    return axios.get(`${base.dev}/services/app/Group/Get`, { params });
  },
  GetBlackListUsersByGroupId(params) {
    return axios.post(
      `${base.dev}/services/app/Group/GetBlackListUsersByGroupId`,
      params
    );
  },
  FindMyGroupRelation(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/FindMyGroupRelation`,
      params
    );
  },
  FindGroupRelation(params) {
    return axios.post(
      `${base.dev}/services/app/Group/FindGroupRelation`,
      params
    );
  },
  GroupFindGroup(params) {
    return axios.post(`${base.dev}/services/app/Group/FindGroup`, params);
  },
  GetMyFriends(params) {
    return axios.post(`${base.dev}/services/app/Friends/GetMyFriends`, params);
  },
  InvitingUsersToJoinTheGroup(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/InvitingUsersToJoinTheGroup`,
      params
    );
  },
  DeleteSockMessage(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/DeleteSockMessage`,
      params
    );
  },
  forbiddenMyGroupRelation(params) {
    return axios.get(
      `${base.dev}/services/app/Friends/forbiddenMyGroupRelation`,
      { params }
    );
  },
  InsertGroup(params) {
    return axios.get(`${base.dev}/services/app/Friends/InsertGroup`, {
      params
    });
  },
  FriendsCheckInvitationGroupRelation(params) {
    return axios.get(
      `${base.dev}/services/app/Friends/CheckInvitationGroupRelation`,
      { params }
    );
  },
  CheckInvitationGroupRelation(params) {
    return axios.get(
      `${base.dev}/services/app/Group/CheckInvitationGroupRelation`,
      { params }
    );
  },
  RefuseGroup(params) {
    return axios.post(`${base.dev}/services/app/Group/RefuseGroup`, params);
  },
  FindInvitationGroupRelation(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/FindInvitationGroupRelation`,
      params
    );
  },
  FindInvitationGroupRelationing(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/FindInvitationGroupRelationing`,
      params
    );
  },
  SendMyToFriends(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/SendMyToFriends`,
      params
    );
  },
  InviteJoinGroup(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/InviteJoinGroup`,
      params
    );
  },
  InviteJoinGroups(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/InviteJoinGroups`,
      params
    );
  },
  DeleteFriends(params) {
    return axios.post(`${base.dev}/services/app/Friends/DeleteFriends`, params);
  },
  GetFindUsersByGroupId(params) {
    return axios.post(
      `${base.dev}/services/app/Group/GetFindUsersByGroupId`,
      params
    );
  },
  AcceptFriends(params) {
    return axios.post(`${base.dev}/services/app/Friends/AcceptFriends`, params);
  },
  blockFriends(params) {
    return axios.post(`${base.dev}/services/app/Friends/blockFriends`, params);
  },
  blockFriendsBatch(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/blockFriendsBatch`,
      params
    );
  },
  bolockFalseFriends(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/bolockFalseFriends`,
      params
    );
  },
  quBolockFalseFriends(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/quBolockFalseFriends`,
      params
    );
  },
  quBolockFalseFriendsBatch(params) {
    return axios.post(
      `${base.dev}/services/app/Friends/quBolockFalseFriendsBatch`,
      params
    );
  },
  blockList(params) {
    return axios.get(`${base.dev}/services/app/Friends/blockList`, { params });
  },
  FriendsGetAll(params) {
    return axios.get(`${base.dev}/services/app/Friends/GetAll`, { params });
  },
  UpdateVideoOrMsg(params) {
    return axios.get(`${base.dev}/services/app/Friends/UpdateVideoOrMsg`, {
      params
    });
  },
  ForbiddenFriends(params) {
    return axios.get(`${base.dev}/services/app/Friends/ForbiddenFriends`, {
      params
    });
  },
  RefuseFriends(params) {
    return axios.get(`${base.dev}/services/app/Friends/RefuseFriends`, {
      params
    });
  },
  FriendsCreate(params) {
    return axios.post(`${base.dev}/services/app/Friends/Create`, params);
  },
  FriendsFindUsers(params) {
    return axios.post(`${base.dev}/services/app/Friends/FindUsers`, params);
  },
  //获取社区数据
  GetSocialData(params) {
    return axios.get(`${base.dev}/services/app/MoiveCommunity/GetAll`, {
      params
    });
  },
  //获取自己社区数据
  GetMySocialData(params) {
    return axios.get(`${base.dev}/services/app/MoiveCommunity/GetMoiveByUser`, {
      params
    });
  },
  //获取单条社区数据
  GetSingleSocialData(params) {
    return axios.get(`${base.dev}/services/app/MoiveCommunity/Get`, { params });
  },
  //创建帖子
  CreateSocialData(params) {
    return axios.post(`${base.dev}/services/app/MoiveCommunity/Create`, params);
  },
  DeleteSocialData(params) {
    return axios.delete(`${base.dev}/services/app/MoiveCommunity/Delete`, {
      params: params
    });
  },
  //获取影片/图片
  GetByUserPhotoDtl(params) {
    return axios.get(
      `${base.dev}/services/app/MoiveCommunity/GetByUserPhotoDtl`,
      { params }
    );
  },
  //点赞，
  SocialDataUpdateStatistics(params) {
    return axios.post(
      `${base.dev}/services/app/MoiveCommunity/UpdateStatistics`,
      params
    );
  },

  //获取收藏列表
  GetFavoriteByUserId(params) {
    return axios.get(
      `${base.dev}/services/app/MoiveCommunity/GetFavoriteByUserId`,
      { params }
    );
  },
  //认证
  CheckName(params) {
    return axios.post(`${base.dev}/services/app/MemEmber/CheckAuth`, params);
  },
  //修改显示状态
  UpdateStat(params) {
    return axios.post(`${base.dev}/services/app/MoiveCommunity/Update`, params);
  },
  //獎牌兌換點數 確定按鈕
  MedalSubmit(params) {
    return axios.post(`${base.dev}/services/app/EventMedal/Submit`, params);
  },
  //奖牌兑换成 点数
  MedalInfo(params) {
    return axios.post(`${base.dev}/services/app/EventMedal/Info`, params);
  },
  //獲取當前用戶的 綜合記錄
  GetInfoList(params) {
    return axios.get(`${base.dev}/services/app/EventMedal/GetInfoList`, {
      params
    });
  },

  //后台
  //获取列表数据
  AdminMoiveCommunity(params) {
    return axios.post(
      `${base.dev}/services/app/AdminMoiveCommunity/GetAll`,
      params
    );
  },
  //修改显示/隐藏
  AdminUpdate(params) {
    return axios.put(
      `${base.dev}/services/app/AdminMoiveCommunity/Update
        `,
      params
    );
  },
  //修改显示/隐藏
  AdminUpdateSelected(params) {
    return axios.put(
      `${base.dev}/services/app/AdminMoiveCommunity/UpdateSelected
        `,
      params
    );
  },
  //删除
  AdminDelete(params) {
    return axios.delete(`${base.dev}/services/app/AdminMoiveCommunity/Delete`, {
      params: params
    });
  },
  AdminVideoReTry(params) {
    return axios.post(
      `${base.dev}/services/app/AdminMoiveCommunity/ReTry`,
      params
    );
  }
};
export default social


// WEBPACK FOOTER //
// ./src/api/social/social.js